import React from 'react';
const ITEMS = [{
  title: 'Módulo 1',
  name: 'Mente Despierta',
  icon: '🧠'
}, {
  title: 'Módulo 2',
  name: 'Movilidad Sin Miedo',
  icon: '🦵'
}, {
  title: 'Módulo 3',
  name: 'Cuidado Experto',
  icon: '🏥'
}, {
  title: 'Módulo 4',
  name: 'Bitácora 360',
  icon: '📋'
}, {
  title: 'Módulo 5',
  name: 'Guía Cuidador',
  icon: '⭐'
}, {
  title: 'Módulo VIP',
  name: '150+ Ejercicios',
  icon: '⚡',
  highlight: true
}, {
  title: 'Bono 1',
  name: 'Cocina Vital',
  icon: '🍎',
  bonus: true
}, {
  title: 'Bono 2',
  name: 'Socialización',
  icon: '👥',
  bonus: true
}, {
  title: 'Bono 3',
  name: 'Hogar Seguro',
  icon: '🏠',
  bonus: true
}];
export const ProductShowcaseSection = () => {
  return <section id="visualizacion" className="bg-familia-light py-12 md:py-16 px-4 md:px-6" data-id="element-196" data-mp="1mzq07ckf5jse">
      <div className="max-w-7xl mx-auto text-center w-full" data-id="element-197" data-mp="3jtuk7t9ut9ji">
        <h2 className="text-[26px] sm:text-4xl md:text-5xl font-display font-bold text-familia-ink mb-8 md:mb-12 leading-tight max-w-4xl mx-auto" data-id="element-198" data-mp="3jve1nn78xqmv">
          Qué te llevás:{' '}
          <span className="text-familia-accent" data-id="element-199" data-mp="1hbeuupojyt5h">
            5 módulos + Módulo VIP + 3 bonos
          </span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5" data-id="element-200" data-mp="17kaeblj8b08j">
          {ITEMS.map(item => <li key={item.title} className={`p-5 md:p-6 rounded-2xl border-2 bg-familia-lightCard flex flex-col items-center justify-center ${item.highlight ? 'border-familia-accent' : item.bonus ? 'border-familia-gold' : 'border-familia-lightBorder'}`} data-id="element-201" data-mp="13ip304mceu0g">
              <span className="text-4xl md:text-5xl mb-3" aria-hidden="true" data-id="element-202" data-mp="1vaegdogrqrxf">
                {item.icon}
              </span>
              <span className="text-[13px] font-bold uppercase tracking-widest text-familia-inkMuted mb-1" data-id="element-203" data-mp="1ra4cchcjebl7">
                {item.title}
              </span>
              <span className="text-[16px] md:text-[17px] font-bold text-familia-ink leading-tight" data-id="element-204" data-mp="ftw7285q0m5u">
                {item.name}
              </span>
            </li>)}
        </ul>

        <div className="mt-10 md:mt-16 max-w-[320px] sm:max-w-[480px] md:max-w-2xl mx-auto" data-id="element-205" data-mp="caxd0i6wcq8b">
          <img src="https://cdn.magicpatterns.com/uploads/xfBQ45cbs8uaXH9nFDdf4y/mockup_vitalidad360_bundle_1x1.webp" alt="Vitalidad 360 — Kit completo con módulos imprimibles, planillas y versión digital" width="672" height="672" loading="lazy" decoding="async" className="w-full h-auto aspect-square object-cover rounded-2xl border border-familia-lightBorder" data-id="element-206" data-mp="hatheijiajoe" />
        </div>
      </div>
    </section>;
};